import { useHasAccess } from 'lib-shared-access-control';
import { MetaConversation } from 'lib-shared-legacy-types';

import { useFeatureFlag } from 'utils/featureFlagging/useFeatureFlag';

import { CustomCards } from '../../cards/customCards/customCards';

type CustomIntegrationCardsProps = {
  metaConversation: MetaConversation;
  isMinimized: boolean;
  index: number;
};

export const CustomIntegrationCards = ({
  metaConversation,
  isMinimized,
  index,
}: CustomIntegrationCardsProps): JSX.Element | null => {
  const flags = useFeatureFlag(['conversation-right-sidebar-visibility']);
  const hasIntegrationAccess = useHasAccess('conversation.integration');

  if (!hasIntegrationAccess || !flags.conversationRightSidebarVisibility) {
    return null;
  }

  return (
    <CustomCards
      sectionIndex={index}
      isMinimized={isMinimized}
      csid={metaConversation.conversation?.id}
    />
  );
};
